"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPortalToServerLinkUser = exports.isPortalToServerAnalyticsAnonymousEvent = exports.isPortalToServerAnalyticsEvent = exports.isAnalyticsUserTrackEvent = exports.AnalyticsUserTrackEventSchema = exports.isAnalyticsSubscriptionPurchasedEvent = exports.isAnalyticsTrackEvent = exports.isAnalyticsIdentifyEvent = exports.isAnalyticsEvent = void 0;
const zod_1 = require("zod");
const type_validation_helpers_1 = require("../helpers/type_validation_helpers");
const segment_types_1 = require("./segment_types");
const AnalyticsEventSchema = zod_1.z.object({
    fluent_time: zod_1.z.string(),
    message_id: zod_1.z.string(),
    original_timestamp: zod_1.z.string(),
    received_at: zod_1.z.string(),
    sent_at: zod_1.z.string(),
    timestamp: zod_1.z.string(),
    type: segment_types_1.SegmentEventTypeSchema,
    user_id: zod_1.z.string().optional(),
});
const isAnalyticsEvent = (v) => type_validation_helpers_1.getTypeValidationFunction(AnalyticsEventSchema)(v, true);
exports.isAnalyticsEvent = isAnalyticsEvent;
const AnalyticsIdentifyEventSchema = AnalyticsEventSchema.extend({
    type: zod_1.z.literal("identify"),
});
exports.isAnalyticsIdentifyEvent = type_validation_helpers_1.getTypeValidationFunction(AnalyticsIdentifyEventSchema);
const AnalyticsTrackEventSchema = AnalyticsEventSchema.extend({
    event: zod_1.z.string(),
    type: zod_1.z.literal("track"),
});
exports.isAnalyticsTrackEvent = type_validation_helpers_1.getTypeValidationFunction(AnalyticsTrackEventSchema);
const AnalyticsSubscriptionPurchasedEventSchema = AnalyticsTrackEventSchema.extend({
    properties_coupon: zod_1.z.string().optional(),
    properties_email: zod_1.z.string(),
    properties_has_trial: zod_1.z.boolean(),
    properties_invoice_date: zod_1.z.string(),
    properties_next_billing_amount: zod_1.z.string().optional(),
    properties_next_billing_on: zod_1.z.string(),
    properties_payment_amount: zod_1.z.string(),
    properties_plan_price: zod_1.z.string(),
    properties_purchased_at_date: zod_1.z.string(),
    properties_subscription_plan: zod_1.z.string(),
    properties_trial_expiration_date: zod_1.z.string().optional(),
    properties_trial_start_date: zod_1.z.string().optional(),
    user_id: zod_1.z.string(),
});
const isAnalyticsSubscriptionPurchasedEvent = (v) => type_validation_helpers_1.getTypeValidationFunction(AnalyticsSubscriptionPurchasedEventSchema)(v, true);
exports.isAnalyticsSubscriptionPurchasedEvent = isAnalyticsSubscriptionPurchasedEvent;
exports.AnalyticsUserTrackEventSchema = AnalyticsTrackEventSchema.extend({
    user_id: zod_1.z.string(),
});
const isAnalyticsUserTrackEvent = (v) => type_validation_helpers_1.getTypeValidationFunction(exports.AnalyticsUserTrackEventSchema)(v);
exports.isAnalyticsUserTrackEvent = isAnalyticsUserTrackEvent;
const PortalToServerEventPropertiesSchema = zod_1.z.record(zod_1.z.union([zod_1.z.string(), zod_1.z.number()]));
const PortalToServerAnalyticsEventSchema = zod_1.z.object({
    properties: PortalToServerEventPropertiesSchema,
    title: zod_1.z.string(),
});
const PortalToServerAnalyticsAnonymousEventSchema = PortalToServerAnalyticsEventSchema.extend({
    anonymousId: zod_1.z.string(),
});
exports.isPortalToServerAnalyticsEvent = type_validation_helpers_1.getTypeValidationFunction(PortalToServerAnalyticsEventSchema);
exports.isPortalToServerAnalyticsAnonymousEvent = type_validation_helpers_1.getTypeValidationFunction(PortalToServerAnalyticsAnonymousEventSchema);
const PortalToServerLinkUserSchema = zod_1.z.object({
    anonymousId: zod_1.z.string(),
});
exports.isPortalToServerLinkUser = type_validation_helpers_1.getTypeValidationFunction(PortalToServerLinkUserSchema);
//# sourceMappingURL=analytics_types.js.map